<template>
  <div class="container container_40 orders">
    <div class="text_large">{{ i18n.trd_orders() }}</div>
    <div class="orders__list-wrap">
      <order-list class="orders__list" :type="ORDER_TYPES.buy" :list="formattedBuyOffers"/>
      <order-list class="orders__list" :type="ORDER_TYPES.sell" :list="formattedSellOffers"/>
    </div>
  </div>
</template>

<script>
  import OrderList from './Orders.List'

  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { ORDER_TYPES } from '@const'
  import { i18n } from '@js/i18n'

  export default {
    name: 'orders',
    components: { OrderList },
    data: _ => ({
      ORDER_TYPES,
      i18n
    }),
    computed: {
      ...mapGetters([
        vuexTypes.buyOffers,
        vuexTypes.sellOffers
      ]),
      formattedBuyOffers () {
        return this.buyOffers.sort((a, b) => { return b.price - a.price })
      },
      formattedSellOffers () {
        return this.sellOffers.sort((a, b) => { return a.price - b.price })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";

  .orders__list-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    @include respond-to(medium) {
      flex-direction: column;
      margin-top: 16px;
    }
  }

  .orders__list {
    width: 100%;

    @include respond-to(medium) {
      margin-bottom: 32px;
    }

    &:first-child {
      margin-right: 16px;

      @include respond-to(medium) {
        margin-right: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/components/orders/Trade.Orders.vue